import { render, staticRenderFns } from "./SettingFields.vue?vue&type=template&id=01767ec1&scoped=true&"
import script from "./SettingFields.vue?vue&type=script&lang=ts&"
export * from "./SettingFields.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01767ec1",
  null
  
)

export default component.exports